const getInitialsFromName = (name) =>
  name
    ?.match(/(\b\S)?/g)
    ?.join('')
    ?.toUpperCase()
    ?.substring(0, 2);
export default getInitialsFromName;
